import { Grid } from '@chakra-ui/react'
import KpiCard from './KpiCard'
import type { KpiData } from '../../../data/mockEstadisticas'

interface KpiGridProps {
  data: KpiData[]
}

export default function KpiGrid({ data }: KpiGridProps) {
  return (
    <Grid
      templateColumns={{
        base: '1fr',
        md: 'repeat(2, 1fr)',
        lg: 'repeat(3, 1fr)',
      }}
      gap={6}
    >
      {data.map((kpi, index) => (
        <KpiCard key={kpi.id} data={kpi} index={index} />
      ))}
    </Grid>
  )
}
